<script setup>

import { ref, inject } from 'vue';

import Listbox from 'primevue/listbox';
import Constante from './Constante.vue';
import ModaleAjoutConstante from '@/components/modales/ModaleAjoutConstante.vue';

const { constantes } = defineProps({
	constantes: Array
});

const selectionSchema = inject('selectionSchema');

const affichageModaleAjoutConstante = ref(false);

function ajouterConstante() {
	affichageModaleAjoutConstante.value = true;
}

</script>

<template>
	<div>
		<div class="entete">
			<label class="titre">Constantes</label>
			<div class="conteneur-boutons">
				<button class="bouton fa-solid fa-plus" @click="ajouterConstante()" />
			</div>
		</div>
		<Listbox class="liste-constantes" 
		  v-model="selectionSchema.constante" 
		  :options="constantes"
		  :selectOnFocus="true"
		  :emptyMessage="'Aucune constante'"
		  :optionLabel="'nom'"
		  :disabled="!constantes.length">
			<template #option="slotProps">
				<Constante :constante="slotProps.option" :selectionne="slotProps.option == selectionSchema.constante" />
			</template>
		</Listbox>
		<ModaleAjoutConstante 
			v-if="affichageModaleAjoutConstante"
			@fermeture="affichageModaleAjoutConstante = false" />
	</div>
</template>

<style scoped>

.liste-constantes {
	height: 15vh !important;
	overflow: auto;
}

.entete {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 2px;
}

</style>